import React from 'react';

const Switch = ({ 
  checked = false, 
  onChange, 
  onClick, 
  disabled = false, 
  name, 
  className = '',
  size = 'medium',
  color = 'primary',
  ...props 
}) => {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }
    if (onClick) {
      onClick(event);
    }
  };

  const switchClasses = [
    'custom-switch',
    `custom-switch--${size}`,
    `custom-switch--${color}`,
    checked ? 'custom-switch--checked' : '',
    disabled ? 'custom-switch--disabled' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={switchClasses}>
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="custom-switch__input"
        {...props}
      />
      <label htmlFor={name} className="custom-switch__label">
        <span className="custom-switch__slider"></span>
      </label>
    </div>
  );
};

export default Switch;
